const regex = /^https?:\/\/(.*)$/;

export default (str) => str.replace(regex, '$1');
